import { getSetting, setSetting, onSettingsChange } from './settings.js';

export function applyTheme(theme) {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  root.setAttribute('data-theme', theme);
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) {
    meta.setAttribute('content', theme === 'light' ? '#fafafa' : '#0a0a0b');
  }
}

export function initTheme() {
  applyTheme(getSetting('theme'));
  onSettingsChange(s => applyTheme(s.theme));
}

export function toggleTheme() {
  const next = getSetting('theme') === 'dark' ? 'light' : 'dark';
  setSetting('theme', next);
}
